module.exports = __webpack_public_path__ + "static/img/bg-pt.b0e2e87a.png";